import type { SVGProps } from 'react';
import { Ref, forwardRef, memo } from 'react';
import { brandGradientStops } from '../../theme/colors';

interface SVGRProps {
  title?: string;
  titleId?: string;
  desc?: string;
  descId?: string;
}

const SvgBannerChatIcon = (
  { title, titleId, desc, descId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    role="img"
    ref={ref}
    aria-labelledby={titleId}
    aria-describedby={descId}
    {...props}
  >
    {desc ? <desc id={descId}>{desc}</desc> : null}
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      d="M13 8H7M17 12H7M21 15C21 15.5304 20.7893 16.0391 20.4142 16.4142C20.0391 16.7893 19.5304 17 19 17H7L3 21V5C3 4.46957 3.21071 3.96086 3.58579 3.58579C3.96086 3.21071 4.46957 3 5 3H19C19.5304 3 20.0391 3.21071 20.4142 3.58579C20.7893 3.96086 21 4.46957 21 5V15Z"
      stroke="url(#banner-chat-gradient)"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <defs>
      <linearGradient
        id="banner-chat-gradient"
        x1="3"
        y1="12"
        x2="21"
        y2="12"
        gradientUnits="userSpaceOnUse"
      >
        {brandGradientStops.map((stop) => (
          <stop key={stop.offset} offset={stop.offset} stopColor={stop.color} />
        ))}
      </linearGradient>
    </defs>
  </svg>
);

const ForwardRef = forwardRef(SvgBannerChatIcon);
const Memo = memo(ForwardRef);
export default Memo;
